import { Colors } from '../colors';

export const Typography = {
  // Banner & Slider
  titlePromo: {
    fontSize: 18,
    textAlign: 'center',
    color: Colors.white,
    fontFamily: 'Nexa Slab xBold',
    fontWeight: 'bold',
  },
  namePromo: {
    fontSize: 36,
    textAlign: 'center',
    color: Colors.white,
    fontFamily: 'Nexa Slab xBold',
    fontWeight: 'bold',
  },
  restrictionPromo: {
    fontSize: 15,
    textAlign: 'center',
    color: Colors.white,
    fontFamily: 'Hk Grotesk Medium',
  },
  restrictionPromoSm: {
    fontSize: 13,
    textAlign: 'center',
    color: Colors.white,
    fontFamily: 'Hk Grotesk Medium',
  },
  seeMenu: {
    fontSize: 10,
    textAlign: 'center',
    color: Colors.white,
    fontFamily: 'Hk Grotesk Bold',
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },

  // Menu & content

  titleMenu: {
    fontSize: 36,
    textAlign: 'left',
    color: Colors.black,
    fontFamily: 'Nexa Slab xBold',
    fontWeight: 'bold',
  },
  category: {
    fontSize: 36,
    textAlign: 'left',
    color: Colors.white,
    fontFamily: 'Nexa Slab xBold',
    fontWeight: 'bold',
  },
  // Price & name
  plateTitleText: {
    fontSize: 18,
    color: Colors.red,
    fontFamily: 'Nexa Slab xBold',
    fontWeight: 'bold',
  },
  plateBodyText: {
    fontSize: 15,
    color: Colors.black,
    fontFamily: 'Hk Grotesk Medium',
  },

  // labels
  label: {
    fontSize: 11,
    color: Colors.red,
    fontFamily: 'Hk Grotesk Bold',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    whiteSpace: 'no-wrap'
  },
  iconFont: {
    fontSize: 15,
    fontFamily: 'Icons'
  }
};
